import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import * as R from "ramda";
import $ from 'jquery';

import { PaySummary } from './../_common/paySummary';
import Emptylustration from '../../../assets/images/svg/057-contract-1.svg';

import { PaiementPartnersTable } from './table';
import { LoadingState } from '../../../_common/loadingState';
import * as Loadings from '../../../constants/loadings/backoffice/payments';
import { useDispatch } from 'react-redux';
import { fetchPartnersInvoices } from '../../../actions/backoffice/payments';


export const PaiementPartners = ({ paymentState }) => {

	const dispatch = useDispatch();
	const searchQuery = useLocation();
	const history = useHistory();
	const pageQuery = new URLSearchParams(searchQuery.search);

	let page = pageQuery.get('page');
	let search = pageQuery.get('search');
	let status = pageQuery.get('status');
	let startDate = pageQuery.get('startDate');
	let endDate = pageQuery.get('endDate');
	let sortBy = pageQuery.get('sortBy');
	let sortDesc = pageQuery.get('sortDesc');

	page = R.isNil(page) ? 1 : parseInt(page);
	search = R.isNil(search) ? "" : search;
	status = R.isNil(status) ? "" : status;
	startDate = R.isNil(startDate) ? "" : startDate;
	endDate = R.isNil(endDate) ? "" : endDate;
	sortBy = R.isNil(sortBy) ? "creationdate" : sortBy;
	sortDesc = R.isNil(sortDesc) ? "true" : sortDesc;

	const [pageSearch, setPageSearch] = useState(search);
	const [date, setDate] = useState({
		startDate: !R.isEmpty(startDate) ? new Date(startDate) : undefined,
		endDate: !R.isEmpty(endDate) ? new Date(endDate) : undefined
	});

	const renderRef = useRef(false);
	const renderDateRef = useRef(false);

	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {

		if (isNaN(page) || page === 0) {
			history.push("/backoffice/paiement/partners");
			return;
		}

		//pageNumber, searchTerm, sortByTerm, sortDesc
		dispatch(fetchPartnersInvoices(page, search, status, startDate, endDate, sortBy, sortDesc));

		// eslint-disable-next-line 
	}, [searchQuery.search, history.location]);

	let timer = null;
	useEffect(() => {

		if (!renderRef.current) {
			renderRef.current = true;
			return;
		};


		if (R.isEmpty(pageSearch)) {
			history.push(`/backoffice/paiement/partners?page=${1}${status !== "" ? "&status=" + status : ""}${startDate !== "" ? "&startDate=" + startDate : ""}${endDate !== "" ? "&endDate=" + endDate : ""}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
			return;
		}

		clearTimeout(timer);
		timer = setTimeout(() => {
			dispatch(fetchPartnersInvoices(page, pageSearch, status, startDate, endDate, sortBy, sortDesc));
		}, 1000);


		return () => clearTimeout(timer);

		// eslint-disable-next-line 
	}, [pageSearch]);


	useEffect(() => {

		if (!renderDateRef.current) {
			renderDateRef.current = true;
			return;
		};

		if (!R.isEmpty(date.startDate) && !R.isNil(date.startDate) && !R.isNil(date.endDate) && !R.isEmpty(date.endDate)) {
			history.push(`/backoffice/paiement/partners?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${status !== "" ? "&status=" + status : ""}${"&startDate=" + (date.startDate.toISOString().slice(0, 10))}${"&endDate=" + (date.endDate.toISOString().slice(0, 10))}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
			return;

		} else if (!R.isEmpty(date.startDate) && !R.isNil(date.startDate)) {
			history.push(`/backoffice/paiement/partners?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${status !== "" ? "&status=" + status : ""}${"&startDate=" + (date.startDate.toISOString().slice(0, 10))}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
			return;

		} else if (!R.isNil(date.endDate) && !R.isEmpty(date.endDate)) {
			history.push(`/backoffice/paiement/partners?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${status !== "" ? "&status=" + status : ""}${"&endDate=" + (date.endDate.toISOString().slice(0, 10))}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
			return;

		} else {
			history.push(`/backoffice/paiement/partners?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${status !== "" ? "&status=" + status : ""}`);
		}

		// eslint-disable-next-line 
	}, [date]);

	const routerQuery = {
		page,
		search,
		status,
		sortBy,
		sortDesc,
		endDate,
		startDate,
		date
	};

	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);


	if (paymentState.isLoading.includes(Loadings.FETCHING_PARTNERS_INVOICES) && R.isNil(paymentState.partnersInvoices)) { return <LoadingState />; }
	if (R.isNil(paymentState.partnersInvoices)) {
		return (<section className="block fs-3 text-center m-auto py-4">
			<img className="img-fluid img-contain container-paper mx-auto  mt-auto mb-4" src={Emptylustration} alt="Assist@" />
			<div className="block text-center container-thin mx-auto mb-auto">
				<h1 className="font-weight-bolder ls-n2 lh-1">Il n'y a pas de factures.</h1>
			</div>
		</section>);
	}


	return (
		<React.Fragment>
			<div className="auto-view h-100 mb-auto">
				<PaiementPartnersTable paymentState={paymentState} pageSearch={pageSearch} setPageSearch={setPageSearch} date={date} setDate={setDate} routerQuery={routerQuery} />
				<PaySummary paymentState={paymentState} />
			</div>
			<div className="container-fluid">
				<nav className="flex-row my-3 justify-content-center" aria-label="Page navigation">
					{paymentState.currentPage > 1 ? <Link to={`/backoffice/paiement/partners?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${routerQuery.status !== "" ? "&status=" + routerQuery.status : ""}${routerQuery.startDate !== "" ? "&startDate=" + routerQuery.startDate : ""}${routerQuery.endDate !== "" ? "&endDate=" + routerQuery.endDate : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i></button>}
					{paymentState.currentPage > 1 ? <Link to={`/backoffice/paiement/partners?page=${paymentState.currentPage - 1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${routerQuery.status !== "" ? "&status=" + routerQuery.status : ""}${routerQuery.startDate !== "" ? "&startDate=" + routerQuery.startDate : ""}${routerQuery.endDate !== "" ? "&endDate=" + routerQuery.endDate : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i></button>}

					<span className="btn rounded-sm bg-dim px-2 py-1 mx-1 d-flex justify-content-center align-items-center fs-aux">{paymentState.currentPage} de {paymentState.totalPages}</span>

					{paymentState.currentPage < paymentState.totalPages ? <Link to={`/backoffice/paiement/partners?page=${paymentState.currentPage + 1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${routerQuery.status !== "" ? "&status=" + routerQuery.status : ""}${routerQuery.startDate !== "" ? "&startDate=" + routerQuery.startDate : ""}${routerQuery.endDate !== "" ? "&endDate=" + routerQuery.endDate : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i></button>}
					{paymentState.currentPage < paymentState.totalPages ? <Link to={`/backoffice/paiement/partners?page=${paymentState.totalPages}${pageSearch !== "" ? "&search=" + pageSearch : ""}${routerQuery.status !== "" ? "&status=" + routerQuery.status : ""}${routerQuery.startDate !== "" ? "&startDate=" + routerQuery.startDate : ""}${routerQuery.endDate !== "" ? "&endDate=" + routerQuery.endDate : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i></button>}
				</nav>
			</div>
		</React.Fragment>
	);
};